// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"8d6c4bda","222":"9d538a2c","238":"4e5d8806","496":"4d03edcb","526":"9e90353e","657":"083ce3ea","678":"1ab44eee","856":"92f98c1f","923":"06d678ce"}[chunkId] + ".chunk.js";
};